import React from "react";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import SquareCard from "./square_card";
import { Frame } from "@bitesite/react-figstrap";
import { Well, LoadingMessage } from "../../odc-ui";

const SquareCardsList = ({
  selectable,
  disableable,
  onChange,
  showEmptyState,
  theme,
}) => {
  const [squareCards, setSquareCards] = useState();
  const [loading, setLoading] = useState(true);
  const [selectedSquareCard, setSelectedSquareCard] = useState();

  const loadSquareCards = () => {
    setLoading(true);
    $.getJSON("/square_cards", (results) => {
      setSquareCards(results);
      setLoading(false);
    });
  };

  useEffect(() => {
    loadSquareCards();
  }, []);

  useEffect(() => {
    if (onChange) {
      onChange(selectedSquareCard);
    }
  }, [selectedSquareCard]);

  return (
    <div>
      {loading && <LoadingMessage message="Loading payment methods" />}
      {!loading && (
        <>
          <Frame gap={10} style={{ flexWrap: "wrap" }}>
            {squareCards.map((squareCard) => (
              <SquareCard
                key={squareCard.id}
                squareCard={squareCard}
                selectable={selectable}
                disableable={disableable}
                theme={theme}
                selected={
                  selectedSquareCard && selectedSquareCard.id === squareCard.id
                }
                onClick={() => {
                  setSelectedSquareCard(squareCard);
                }}
                onDisable={() => {
                  loadSquareCards();
                }}
              />
            ))}
          </Frame>
          {showEmptyState && squareCards.length === 0 && (
            <Well>
              You do not currently have any credit cards setup on your account.
            </Well>
          )}
        </>
      )}
    </div>
  );
};

SquareCardsList.defaultProps = {
  showEmptyState: true,
};

SquareCardsList.propTypes = {
  selectable: PropTypes.bool,
  disableable: PropTypes.bool,
  onChange: PropTypes.func,
  showEmptyState: PropTypes.bool,
  theme: PropTypes.string,
};

export default SquareCardsList;
